export default "__VITE_ASSET__23917f83__"